import { cn } from '@/utils/cn'
import { type IconProps, iconVariants } from './common'

interface ProgressCircleIconProps extends IconProps {
  progress?: number
}

export function ProgressCircleIcon({ className, size = 24, progress = 0, ...props }: ProgressCircleIconProps) {
  const radius = 9
  const circumference = 2 * Math.PI * radius
  const offset = circumference * (1 - Math.max(0, Math.min(100, progress)) / 100)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <circle cx="12" cy="12" r={radius} fill="none" stroke="currentColor" strokeOpacity={0.2} strokeWidth={2} />
      <circle
        cx="12"
        cy="12"
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform="translate(24 0) scale(-1 1) rotate(-90 12 12)"
      />
    </svg>
  )
}
